import { render } from "./SaveWorkExperience.vue?vue&type=template&id=4399265d"
import script from "./SaveWorkExperience.vue?vue&type=script&lang=js"
export * from "./SaveWorkExperience.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__